import { _get, _post, _put } from "lib/rest";
import { jobType } from "./sentiment.type";

export const getJob = async (pid: number, id: number) =>
  await _get(`/sentiment/project/${pid}/jobs/${id}/`);

export const getJobs = async (pid: number, data: jobType) =>
  await _get(`/sentiment/project/${pid}/jobs/`, data);

export const createSentiment = async (pid: number, text: string[]) =>
  await _post(`/sentiment/project/${pid}/channels/words/`, { text });

//데모 관련 api들들
export const startDemo = async (pid: number, data: { text: string }) =>
  await _post(`/sentiment/project/${pid}/demo/`, data);

export const voteDemo = async (pid: number, id: number, feedback: number) =>
  await _put(`/sentiment/project/${pid}/demo/${id}/`, { feedback });
